import React, { useState } from 'react';
import { Typography } from 'antd';
import { ConjugationTable, TenseKey } from '@lingoping/core';

const { Text } = Typography;

const TENSES: { key: TenseKey; label: string }[] = [
  { key: 'praesens', label: 'Präsens' },
  { key: 'praeteritum', label: 'Präteritum' },
  { key: 'perfekt', label: 'Perfekt' },
  { key: 'plusquamperfekt', label: 'Plusquamperfekt' },
  { key: 'futur1', label: 'Futur I' },
  { key: 'futur2', label: 'Futur II' },
  { key: 'konjunktiv1', label: 'Konjunktiv I' },
  { key: 'konjunktiv2', label: 'Konjunktiv II' },
  { key: 'imperativ', label: 'Imperativ' },
];

const PERSONS = ['ich', 'du', 'er/sie/es', 'wir', 'ihr', 'sie/Sie'];

/**
 * Tense buttons + a single 6-row table. The buttons are real <button>s (keyboard and screen-reader
 * friendly); clicks never bubble, so it works on a flippable card.
 */
export const ConjugationTabs: React.FC<{ table: ConjugationTable }> = ({ table }) => {
  const [active, setActive] = useState<TenseKey>('praesens');
  const forms = table.tenses[active];

  return (
    <div onClick={(e) => e.stopPropagation()} style={{ width: '100%' }}>
      <div
        role="group"
        aria-label="Tense"
        style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 8 }}
      >
        {TENSES.filter((t) => table.tenses[t.key]?.some(Boolean)).map((t) => {
          const selected = active === t.key;
          return (
            <button
              key={t.key}
              type="button"
              aria-pressed={selected}
              onClick={() => setActive(t.key)}
              style={{
                fontSize: 12,
                lineHeight: '20px',
                padding: '1px 8px',
                borderRadius: 6,
                cursor: 'pointer',
                fontFamily: 'inherit',
                border: `1px solid ${selected ? '#1677ff' : '#d9d9d9'}`,
                background: selected ? '#1677ff' : '#ffffff',
                color: selected ? '#ffffff' : '#334155',
              }}
            >
              {t.label}
            </button>
          );
        })}
      </div>
      <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
        <tbody>
          {PERSONS.map((person, i) =>
            forms[i] ? (
              <tr key={person} style={{ borderTop: '1px solid #f0f0f0' }}>
                <td style={{ padding: '3px 0', width: '38%' }}>
                  <Text style={{ color: '#475569' }}>{person}</Text>
                </td>
                <td style={{ padding: '3px 0', fontWeight: 500 }}>{forms[i]}</td>
              </tr>
            ) : null
          )}
        </tbody>
      </table>
    </div>
  );
};
